var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgGamesTab = function SvgGamesTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48469_31096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11C5.94771 11 5.5 11.4478 5.5 12C5.5 12.5522 5.94771 13 6.5 13H14.5C15.0523 13 15.5 12.5522 15.5 12C15.5 11.4478 15.0523 11 14.5 11H6.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5C6 7.94775 6.44771 7.5 7 7.5C7.55229 7.5 8 7.94775 8 8.5C8 9.05225 7.55229 9.5 7 9.5C6.44771 9.5 6 9.05225 6 8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C6.44771 14.5 6 14.9478 6 15.5C6 16.0522 6.44771 16.5 7 16.5C7.55229 16.5 8 16.0522 8 15.5C8 14.9478 7.55229 14.5 7 14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5C13 7.94775 13.4477 7.5 14 7.5C14.5523 7.5 15 7.94775 15 8.5C15 9.05225 14.5523 9.5 14 9.5C13.4477 9.5 13 9.05225 13 8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5C13.4477 14.5 13 14.9478 13 15.5C13 16.0522 13.4477 16.5 14 16.5C14.5523 16.5 15 16.0522 15 15.5C15 14.9478 14.5523 14.5 14 14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5C9.5 7.94775 9.94771 7.5 10.5 7.5C11.0523 7.5 11.5 7.94775 11.5 8.5C11.5 9.05225 11.0523 9.5 10.5 9.5C9.94771 9.5 9.5 9.05225 9.5 8.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.5C9.94771 14.5 9.5 14.9478 9.5 15.5C9.5 16.0522 9.94771 16.5 10.5 16.5C11.0523 16.5 11.5 16.0522 11.5 15.5C11.5 14.9478 11.0523 14.5 10.5 14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4C3.39543 4 2.5 4.89539 2.5 6V18C2.5 19.1046 3.39543 20 4.5 20H16.5C17.6046 20 18.5 19.1046 18.5 18V13H21.5C22.0523 13 22.5 12.5522 22.5 12V9C23.6046 9 24.5 8.10461 24.5 7C24.5 5.89539 23.6046 5 22.5 5C21.3954 5 20.5 5.89539 20.5 7V11H18.5V6C18.5 4.89539 17.6046 4 16.5 4H4.5ZM16.5 6V18H4.5V6H16.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48469_31096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(0.5)"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgGamesTab);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/games-tab.a8c685027609d5fe8609d71a363b1541.svg";